/**
 * Two-pane station layout: queue/list left, active item right (tablet landscape).
 */
import React from 'react';

export default function StationLayout({ queue, children, title = 'Scan station' }) {
  return (
    <div className="station-layout" data-testid="station-layout">
      <aside className="station-queue" data-testid="station-queue">
        <h2>{title}</h2>
        {queue}
      </aside>
      <main className="station-main" data-testid="station-main">
        {children}
      </main>
    </div>
  );
}
